module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "cardProduct",
    staticClass: "card-product-big",
    on: {
      "mouseover": function($event) {
        _vm.changeStyle('border')
      },
      "mouseleave": function($event) {
        _vm.changeStyle()
      }
    }
  }, [_c('div', {
    staticClass: "products-wrapper relative",
    class: {
      'margin-auto': _vm.isPossiblyLike, 'wrapper-like': _vm.isPossiblyLike
    },
    on: {
      "click": function($event) {
        _vm.goToProduct(_vm.product)
      }
    }
  }, [_c('div', {
    class: [
      'wrapper-discount', 'd-flex',
      _vm.hideHeart ? 'justify-end' : 'space-between' ]
  }, [(!_vm.hideHeart) ? _c('heart-svg', {
    attrs: {
      "active": Number(_vm.product.flagFavorite)
    },
    on: {
      "click": _vm.addToFavorites
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "discount",
    staticClass: "number-discount",
    style: (("background-color:" + (_vm.globalColors.titulo)))
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.discountPercentage) + "%")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-image-product d-flex align-center justify-center"
  }, [_c('div', {
    staticClass: "number-discount-mobile",
    style: (("background-color:" + (_vm.globalColors.titulo)))
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.discountPercentage) + "%")])]), _vm._v(" "), _c('img', {
    staticClass: "products-image",
    class: {
      'image-like': _vm.isPossiblyLike
    },
    attrs: {
      "src": _vm.product.urlImage,
      "alt": _vm.product.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mobil-container"
  }, [_c('div', {
    staticClass: "wrapper-description"
  }, [_c('div', {
    staticClass: "like-mobile"
  }, [_c('heart-svg', {
    attrs: {
      "active": _vm.product.flagFavorite
    },
    on: {
      "click": _vm.addToFavorites
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-product-name"
  }, [_vm._v(_vm._s(_vm.getProductName))]), _vm._v(" "), _c('p', {
    staticClass: "text-description"
  }, [_vm._v(_vm._s(_vm.capitalizeDescription))]), _vm._v(" "), (_vm.product.price) ? _c('p', {
    staticClass: "text-price-now"
  }, [_c('del', [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.product.price)))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-price-before",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.product.priceDiscount)))])]), _vm._v(" "), _c('p', {
    staticClass: "txt-center text-grey"
  }, [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), (_vm.noStock) ? _c('div', {
    staticClass: "wraper-is-not-stock"
  }, [_c('span', {
    staticClass: "text-is-not"
  }, [_vm._v("AGOTADO")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47cb43a0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cardProductBig.vue
// module id = 485
// module chunks = 1 4 5 6